import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import ConfigMigrationDAO from 'config-migration/ConfigMigrationDAO';

import EmptySidebarIcon from './EmptySidebarIcon';
import * as SidebarConstants from './SidebarConstants';
import SidebarItem from './SidebarItem';

// The Tools section in Settings should be enabled if any of the tools are enabled
// Currently the only one is config migration tool
export function isToolsSectionEnabled(): boolean {
  return BenchlingConfig.MIGRATION_ENABLE_CONFIG_MIGRATION;
}

interface ToolsSettingsProps {
  section: SidebarConstants.Section;
}

export default function ToolsSettings(props: ToolsSettingsProps): JSX.Element {
  return (
    <div>
      <div className="browser-nav-header">Tools</div>
      <SidebarItem
        active={props.section === SidebarConstants.Section.CONFIG_MIGRATION}
        icon={<EmptySidebarIcon />}
        name="Configuration migration"
        link={ConfigMigrationDAO.getConfigMigrationURL()}
      />
    </div>
  );
}
